package pl.nickers.match3

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import pl.nickers.match3.ecs.FamiliarType

private data class FamiliarOption(
    val type: FamiliarType,
    val title: String,
    val description: String,
)

/** Familiars the player can currently bring into a level (those with implemented logic). */
private val SELECTABLE_FAMILIARS = listOf(
    FamiliarOption(
        FamiliarType.CONJURER,
        "Conjurer",
        "Collect 12 of your main ingredient to transmute 3 board jellies into it.",
    ),
    FamiliarOption(
        FamiliarType.BLACK_CAT,
        "Black Cat",
        "Collect 10 goal ingredients to transmute a board piece into the one you need most.",
    ),
)

/**
 * Pre-level Familiar selection screen (US4.3). Shows the available Familiars, lets the
 * player pick one, and persists the choice via [onSelect]. Only one Familiar is active at
 * a time; the current selection is highlighted.
 */
@Composable
fun FamiliarSelectScreen(
    selected: FamiliarType,
    onSelect: (FamiliarType) -> Unit,
    onBack: () -> Unit,
) {
    var current by remember { mutableStateOf(selected) }
    Column(
        modifier = Modifier
            .fillMaxSize()
            .padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Text(
            text = "Choose your Familiar",
            fontSize = 32.sp,
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.primary,
        )
        Spacer(Modifier.height(32.dp))
        SELECTABLE_FAMILIARS.forEach { option ->
            val isSelected = option.type == current
            Button(
                onClick = {
                    current = option.type
                    onSelect(option.type)
                },
                modifier = Modifier.fillMaxWidth(0.8f),
                colors = if (isSelected) {
                    ButtonDefaults.buttonColors()
                } else {
                    ButtonDefaults.outlinedButtonColors()
                },
            ) {
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    Text(
                        text = if (isSelected) "${option.title}  ✓" else option.title,
                        fontSize = 20.sp,
                        fontWeight = FontWeight.SemiBold,
                    )
                    Text(text = option.description, fontSize = 13.sp)
                }
            }
            Spacer(Modifier.height(16.dp))
        }
        Spacer(Modifier.height(16.dp))
        OutlinedButton(
            onClick = onBack,
            modifier = Modifier.fillMaxWidth(0.6f),
        ) {
            Text("Back", fontSize = 18.sp)
        }
    }
}
